import {
  CREATE_CALCULATOR,
  DELETE_CALCULATOR,
  HIDE_ADD_EDIT_MODAL,
  SET_DATA,
  SHOW_ADD_EDIT_MODAL,
  UPDATE_CALCULATOR,
} from './mutation-types';

export default {
  [SET_DATA](state, data) {
    state.data = data;
  },
  [SHOW_ADD_EDIT_MODAL](state, calculator) {
    state.addEditModal.show = true;
    state.addEditModal.data = calculator;
  },
  [HIDE_ADD_EDIT_MODAL](state) {
    state.addEditModal.show = false;
  },
  [DELETE_CALCULATOR](state, loanCalculatorId) {
    state.data = state.data.filter(i => i.loanCalculatorId !== loanCalculatorId);
  },
  [CREATE_CALCULATOR](state, calculator) {
    state.data.unshift(calculator);
  },
  [UPDATE_CALCULATOR](state, calculator) {
    state.data = state.data.map(item => {
      if (item.loanCalculatorId === calculator.loanCalculatorId) {
        item = calculator;
      }
      return item;
    });
  },
};
